<template>
  <div class="modal-card membership-cancel-preview">
    <header class="modal-card-head">
      <p class="modal-card-title">{{ $t('title') }}</p>
      <button type="button" class="delete" aria-label="close" @click="emitCancel" />
    </header>

    <section class="modal-card-body">
      <p class="membership-cancel-preview__intro">
        {{ $t('intro', { name: membershipName }) }}
      </p>

      <div v-if="visibleItems.length">
        <ul class="membership-cancel-preview__list">
          <li v-for="item in visibleItems" :key="itemKey(item)">
            {{ getItemLabel(item) }}
          </li>
        </ul>
      </div>
      <p v-else class="membership-cancel-preview__empty">
        {{ $t('empty_state') }}
      </p>
    </section>

    <footer class="modal-card-foot is-justify-content-flex-end">
      <b-button type="is-text" @click="emitCancel">
        {{ $t('actions.cancel') }}
      </b-button>
      <b-button type="is-warning" @click="emitConfirm">
        {{ $t('actions.proceed') }}
      </b-button>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'MembershipCancelPreviewModal',
  props: {
    membership: {
      type: Object,
      required: true,
    },
  },
  computed: {
    membershipName() {
      return this.membership?.membership?.name
        || this.membership?.name
        || '';
    },
    visibleItems() {
      const collections = [
        this.membership?.items,
        this.membership?.membership?.items,
        this.membership?.membership?.membership_items,
      ];

      const merged = collections.reduce((acc, list) => {
        if (Array.isArray(list)) {
          list.forEach((item) => {
            if (item) {
              acc.push(item);
            }
          });
        }
        return acc;
      }, []);

      const seen = new Set();

      return merged.filter((item) => {
        const key = this.itemKey(item);
        if (!key) {
          return true;
        }
        if (seen.has(key)) {
          return false;
        }
        seen.add(key);
        return true;
      });
    },
  },
  methods: {
    emitCancel() {
      this.$emit('cancel');
      this.$emit('close');
    },
    emitConfirm() {
      this.$emit('confirm');
    },
    getItemLabel(item) {
      if (item?.buyable?.name) {
        return item.buyable.name;
      }
      if (item?.name) {
        return item.name;
      }
      return this.$t('content_removed');
    },
    itemKey(item) {
      return item?.uuid || item?.id || item?.buyable_uuid || null;
    },
  },
  i18n: {
    messages: {
      fr: {
        title: 'Contenus inclus dans votre abonnement',
        intro: 'Vous êtes sur le point d\'annuler votre abonnement "{name}". Vous perdrez l\'accès aux formations suivantes :',
        empty_state: 'Cet abonnement ne contient aucun contenu associé.',
        content_removed: 'Contenu supprimé',
        actions: {
          cancel: 'Retour',
          proceed: 'Continuer',
        },
      },
      en: {
        title: 'Content included with your membership',
        intro: 'You are about to cancel your "{name}" membership. You will lose access to the following trainings:',
        empty_state: 'This membership does not include any content.',
        content_removed: 'Content removed',
        actions: {
          cancel: 'Go back',
          proceed: 'Continue',
        },
      },
    },
  },
};
</script>

<style scoped>
.membership-cancel-preview {
  width: 520px;
  max-width: calc(100vw - 32px);
}

.membership-cancel-preview__intro {
  font-size: 0.95rem;
  line-height: 1.5;
  margin-bottom: 1.25rem;
}

.membership-cancel-preview__list {
  margin: 0;
  padding-left: 1.25rem;
  max-height: 260px;
  overflow-y: auto;
  list-style: disc;
  list-style-position: outside;
}

.membership-cancel-preview__list li {
  line-height: 1.5;
  margin-bottom: 0.35rem;
  color: #363636;
}

.membership-cancel-preview__empty {
  text-align: center;
  color: #7a7a7a;
  font-size: 0.9rem;
}

.modal-card-foot {
  gap: 0.5rem;
}
</style>
